import styled from "styled-components";

export const Button = styled.button`
  background-color: transparent;
  border: none;
  color: #00acc1;
  cursor: pointer;
`;
